module.exports = __webpack_public_path__ + "img/product_img_2.5102aff2.jpg";